module.exports = __webpack_public_path__ + "img/E-Wallet-pana.e049bfcb.svg";